// import 'babel-polyfill';
// import '@babel/polyfill'
// import "core-js/stable"
// import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/reset.css'
import './assets/css/common.css'
import preventReClick from './utils/preventReClick'
import { fabric } from 'fabric'
import ElTableInfiniteScroll from "el-table-infinite-scroll";
import cssVars from 'css-vars-ponyfill'
cssVars({})

import '@/assets/icon/myIcon/iconfont.css'
import '@/assets/icon/myIcon/iconfont.js'

// 引入 element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/mainfont/iconfont.css'
// 引入vue播放器插件
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
// 复制
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(VueVideoPlayer)
Vue.use(ElementUI)
Vue.use(fabric);
Vue.use(preventReClick)
Vue.directive("el-table-infinite-scroll", ElTableInfiniteScroll);
Vue.config.productionTip = false
Vue.filter( 'timeFormat', (time)=>{
  let timeArr = time.split(' ')
  let a = timeArr[0].split('-')
  a.shift()
  let timeFirst = a.join('-')
  let j = timeArr[1].split(':')
  j.pop()
  let timeLast = j.join(':')
  return timeFirst + ' ' + timeLast
} )
Vue.filter( 'timeFormatCopy', (time)=>{
  let timeArr = time.split(' ')
  let a = timeArr[0].split('-')
  // a.shift()
  let timeFirst = a.join('-')
  return timeFirst
} )
Vue.filter('timeDuration',(d)=>{
  var hours = Math.floor(d / 3600);
  var minutes = Math.floor((d - (hours * 3600)) / 60);
  var seconds = d % 60;
 
  return [hours, minutes, seconds]
    .map(num => num < 10 ? '0' + num : num.toString())
    .filter(num => num)
    .join(':');
})
Vue.filter('size',(b)=>{
  b = Number(b);
  if(b<1024){
    return b + 'K'
  }else{
    if(b/1024>1&& b/1024<=1024){
      return (b/1024).toFixed(2) + 'M'
    }else{
      return (b/1024/1024).toFixed(2) + 'G'
    }
  }
  
})

Vue.filter('consume',(d)=>{
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);

  var hDisplay = h > 0 ? h + "时" : ""
  var mDisplay = m > 0 ? m + "分" : ""
  var sDisplay = s > 0 ? s + "秒" : ""
  if(!hDisplay&&!mDisplay &&!sDisplay){
    return 1 + '秒'
  }else{
    return hDisplay + mDisplay + sDisplay;
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
